import React from 'react';
import { BETA_SKILLS, formatSkillDisplayName } from './skillsConfig';
import './SkillsPage.css';

/**
 * SkillCard: THE skill card, one component for every surface that lists skills (Sep 23 2026, Nitish: "rather than
 * reinventing it, we just reuse it"). Rendered by the public agent-to-agent skills page (/skills) and by the Delegate
 * app's Skills tab (/delegate/skills through SkillsCatalog). Styles live in SkillsPage.css (.skill-card*), keyed to
 * the card's own light/dark class so it renders the same inside or outside the public page shell.
 * Extra props (data-track, data-skill, aria-*) pass through to the card element.
 */
// showBrand={false} drops "— CellCog" from the heading: the Delegate > Skills tab only (Nitish, Sep 23 2026).
const SkillCard = ({ skill, onClick, isDarkMode, className = '', showBrand = true, ...rest }) => {
  const isBeta = BETA_SKILLS.has(skill.slug);
  const open = () => onClick(skill.slug);
  return (
    <div
      className={`skill-card ${isDarkMode ? 'dark' : 'light'} ${className}`.trim()}
      onClick={open}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }}
      {...rest}
    >
      <div className="skill-card-emoji" aria-hidden="true">{skill.emoji}</div>
      <div className="skill-card-body">
        <div className="skill-card-name">
          {formatSkillDisplayName(skill.name, { brand: showBrand })}
          {isBeta && <span className="skill-beta-tag">Beta</span>}
        </div>
        <div className="skill-card-description">{skill.description}</div>
      </div>
    </div>
  );
};

export default SkillCard;
